var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.extras.groupAgendaDisplay.display == 1)?_c('div',{staticClass:"m-pc-metting-schedule top-nav new",style:({
    background:
      _vm.extras.agendaBg.colorOrBg == 'color'
        ? _vm.extras.agendaBg.color
        : 'url(' + _vm.extras.agendaBg.src + ')',
  }),attrs:{"id":"schedule"}},[_c('div',{staticClass:"pc-metting-content u-w1200"},[(_vm.extras.scheduleTitle.display == 1)?_c('Title',{attrs:{"title":_vm.extras.scheduleTitle.mainTitle || _vm.title,"en":_vm.extras.scheduleTitle.subTitle || 'AGENDA',"extras":_vm.extras}}):_vm._e(),_c('div',{staticClass:"pc-agendas-info"},[(_vm.agendas.length > 0)?_c('div',{staticClass:"pc-content-info"},[(_vm.agendas.length > 4)?_c('swiper',{staticClass:"pc-metting-time new",attrs:{"options":_vm.swiperOptions}},_vm._l((_vm.agendas),function(item,index){return _c('swiper-slide',{key:index,staticClass:"date-new swiper-slide",class:{
              'cursor-default': _vm.isSetting == 1,
              active: item.agendaDate == _vm.currentId,
            },style:({
              background:
                item.agendaDate == _vm.currentId
                  ? _vm.extras.agendaSetting.angendaDayBgActive == 'src'
                    ? 'url(' + _vm.extras.agendaSetting.src + ')'
                    : _vm.extras.agendaSetting.color
                  : _vm.extras.agendaSetting.angendaDayBg == 'src'
                  ? 'url(' + _vm.extras.agendaSetting.imgUrl + ')'
                  : _vm.extras.agendaSetting.color2,
            })},[_c('div',{staticClass:"date-cnt-new",class:{},on:{"click":function($event){return _vm.DayClick(item)}}},[_c('div',{staticClass:"title",style:({
                  color:
                    item.agendaDate == _vm.currentId
                      ? _vm.extras.agendaSetting.text4 == 'custom'
                        ? _vm.extras.agendaSetting.fontColor4 + ' !important'
                        : ''
                      : _vm.extras.agendaSetting.text3 == 'custom'
                      ? _vm.extras.agendaSetting.fontColor3
                      : '',
                  'font-size':
                    item.agendaDate == _vm.currentId
                      ? _vm.extras.agendaSetting.text4 == 'custom'
                        ? _vm.extras.agendaSetting.fontSize4 + 'px'
                        : ''
                      : _vm.extras.agendaSetting.text3 == 'custom'
                      ? _vm.extras.agendaSetting.fontSize3 + 'px'
                      : '',
                  'font-style':
                    item.agendaDate == _vm.currentId
                      ? _vm.extras.agendaSetting.text4 == 'custom'
                        ? _vm.extras.agendaSetting.fontTilt4 == 'on'
                          ? 'italic'
                          : 'normal'
                        : ''
                      : _vm.extras.agendaSetting.text3 == 'custom'
                      ? _vm.extras.agendaSetting.fontTilt3 == 'on'
                        ? 'italic'
                        : 'normal'
                      : '',
                  'font-Weight':
                    item.agendaDate == _vm.currentId
                      ? _vm.extras.agendaSetting.text4 == 'custom'
                        ? _vm.extras.agendaSetting.fontWeight4 == 'on'
                          ? 'bolder'
                          : ''
                        : ''
                      : _vm.extras.agendaSetting.text3 == 'custom'
                      ? _vm.extras.agendaSetting.fontWeight3 == 'on'
                        ? 'bolder'
                        : ''
                      : '',
                })},[_vm._v(" "+_vm._s(_vm.extras.agendaSetting.type == "en" ? "DAY" + (index + 1) : "第" + (index + 1) + "天")+" ")]),_c('span',{style:({
                  color:
                    item.agendaDate == _vm.currentId
                      ? _vm.extras.agendaSetting.textActive == 'custom'
                        ? _vm.extras.agendaSetting.fontColor2 + ' !important'
                        : ''
                      : _vm.extras.agendaSetting.text == 'custom'
                      ? _vm.extras.agendaSetting.fontColor
                      : '',
                  'font-size':
                    item.agendaDate == _vm.currentId
                      ? _vm.extras.agendaSetting.textActive == 'custom'
                        ? _vm.extras.agendaSetting.fontSize2 + 'px'
                        : ''
                      : _vm.extras.agendaSetting.text == 'custom'
                      ? _vm.extras.agendaSetting.fontSize + 'px'
                      : '',
                  'font-style':
                    item.agendaDate == _vm.currentId
                      ? _vm.extras.agendaSetting.textActive == 'custom'
                        ? _vm.extras.agendaSetting.fontTilt2 == 'on'
                          ? 'italic'
                          : 'normal'
                        : ''
                      : _vm.extras.agendaSetting.text == 'custom'
                      ? _vm.extras.agendaSetting.fontTilt == 'on'
                        ? 'italic'
                        : 'normal'
                      : '',
                  'font-Weight':
                    item.agendaDate == _vm.currentId
                      ? _vm.extras.agendaSetting.textActive == 'custom'
                        ? _vm.extras.agendaSetting.fontWeight2 == 'on'
                          ? 'bolder'
                          : ''
                        : ''
                      : _vm.extras.agendaSetting.text == 'custom'
                      ? _vm.extras.agendaSetting.fontWeight == 'on'
                        ? 'bolder'
                        : ''
                      : '',
                })},[_vm._v(_vm._s(_vm._f("formatDateNew")(item.agendaDate)))])])])}),1):_vm._e(),(_vm.agendas.length < 5 && _vm.agendas.length > 1)?_c('div',{staticClass:"pc-metting-time new auto-flex"},_vm._l((_vm.agendas),function(item,index){return _c('div',{key:index,staticClass:"date-new",class:{
              'cursor-default': _vm.isSetting == 1,
              active: item.agendaDate == _vm.currentId,
              'tab-length2': _vm.agendas.length == 2,
              'tab-length3': _vm.agendas.length == 3,
              'tab-length4': _vm.agendas.length == 4,
            },style:({
              background:
                item.agendaDate == _vm.currentId
                  ? _vm.extras.agendaSetting.angendaDayBgActive == 'src'
                    ? 'url(' + _vm.extras.agendaSetting.src + ')'
                    : _vm.extras.agendaSetting.color
                  : _vm.extras.agendaSetting.angendaDayBg == 'src'
                  ? 'url(' + _vm.extras.agendaSetting.imgUrl + ')'
                  : _vm.extras.agendaSetting.color2,
            })},[_c('div',{staticClass:"date-cnt-new",on:{"click":function($event){return _vm.DayClick(item)}}},[_c('div',{staticClass:"title",style:({
                  color:
                    item.agendaDate == _vm.currentId
                      ? _vm.extras.agendaSetting.text4 == 'custom'
                        ? _vm.extras.agendaSetting.fontColor4 + ' !important'
                        : ''
                      : _vm.extras.agendaSetting.text3 == 'custom'
                      ? _vm.extras.agendaSetting.fontColor3
                      : '',
                  'font-size':
                    item.agendaDate == _vm.currentId
                      ? _vm.extras.agendaSetting.text4 == 'custom'
                        ? _vm.extras.agendaSetting.fontSize4 + 'px'
                        : ''
                      : _vm.extras.agendaSetting.text3 == 'custom'
                      ? _vm.extras.agendaSetting.fontSize3 + 'px'
                      : '',
                  'font-style':
                    item.agendaDate == _vm.currentId
                      ? _vm.extras.agendaSetting.text4 == 'custom'
                        ? _vm.extras.agendaSetting.fontTilt4 == 'on'
                          ? 'italic'
                          : 'normal'
                        : ''
                      : _vm.extras.agendaSetting.text3 == 'custom'
                      ? _vm.extras.agendaSetting.fontTilt3 == 'on'
                        ? 'italic'
                        : 'normal'
                      : '',
                  'font-Weight':
                    item.agendaDate == _vm.currentId
                      ? _vm.extras.agendaSetting.text4 == 'custom'
                        ? _vm.extras.agendaSetting.fontWeight4 == 'on'
                          ? 'bolder'
                          : ''
                        : ''
                      : _vm.extras.agendaSetting.text3 == 'custom'
                      ? _vm.extras.agendaSetting.fontWeight3 == 'on'
                        ? 'bolder'
                        : ''
                      : '',
                })},[_vm._v(" "+_vm._s(_vm.extras.agendaSetting.type == "en" ? "DAY" + (index + 1) : "第" + (index + 1) + "天")+" ")]),_c('div',{staticClass:"split-str"}),_c('span',{style:({
                  color:
                    item.agendaDate == _vm.currentId
                      ? _vm.extras.agendaSetting.textActive == 'custom'
                        ? _vm.extras.agendaSetting.fontColor2 + ' !important'
                        : ''
                      : _vm.extras.agendaSetting.text == 'custom'
                      ? _vm.extras.agendaSetting.fontColor
                      : '',
                  'font-size':
                    item.agendaDate == _vm.currentId
                      ? _vm.extras.agendaSetting.textActive == 'custom'
                        ? _vm.extras.agendaSetting.fontSize2 + 'px'
                        : ''
                      : _vm.extras.agendaSetting.text == 'custom'
                      ? _vm.extras.agendaSetting.fontSize + 'px'
                      : '',
                  'font-style':
                    item.agendaDate == _vm.currentId
                      ? _vm.extras.agendaSetting.textActive == 'custom'
                        ? _vm.extras.agendaSetting.fontTilt2 == 'on'
                          ? 'italic'
                          : 'normal'
                        : ''
                      : _vm.extras.agendaSetting.text == 'custom'
                      ? _vm.extras.agendaSetting.fontTilt == 'on'
                        ? 'italic'
                        : 'normal'
                      : '',
                  'font-Weight':
                    item.agendaDate == _vm.currentId
                      ? _vm.extras.agendaSetting.textActive == 'custom'
                        ? _vm.extras.agendaSetting.fontWeight2 == 'on'
                          ? 'bolder'
                          : ''
                        : ''
                      : _vm.extras.agendaSetting.text == 'custom'
                      ? _vm.extras.agendaSetting.fontWeight == 'on'
                        ? 'bolder'
                        : ''
                      : '',
                })},[_vm._v(_vm._s(_vm._f("formatDate")(item.agendaDate)))])])])}),0):_vm._e(),_c('div',{ref:"ScheduleTab",staticStyle:{"position":"relative","overflow":"hidden"}},[(
              _vm.extras && _vm.extras.subSeminar && _vm.extras.subSeminar.display == 1
            )?_c('div',{directives:[{name:"show",rawName:"v-show",value:(
              (_vm.agendasJson &&
                _vm.agendasJson.itemsSubSeminar &&
                _vm.agendasJson.itemsSubSeminar.length > 0) ||
              _vm.isSetting == 1
            ),expression:"\n              (agendasJson &&\n                agendasJson.itemsSubSeminar &&\n                agendasJson.itemsSubSeminar.length > 0) ||\n              isSetting == 1\n            "}],staticClass:"m-tab-list-new",class:'tab-length' +
              (_vm.agendasJson && _vm.agendasJson.itemsSubSeminar
                ? _vm.agendasJson.itemsSubSeminar.length +
                  (_vm.agendasJson.items.length > 0 ? 1 : 0)
                : ''),staticStyle:{"display":"inline-block","white-space":"nowrap","height":"44px"},style:({
              width:
                _vm.agendasJson &&
                _vm.agendasJson.itemsSubSeminar &&
                _vm.agendasJson.itemsSubSeminar.length <
                  (_vm.agendasJson.items.length > 0 ? 4 : 5)
                  ? 'auto'
                  : '',
              display:
                _vm.agendasJson &&
                _vm.agendasJson.itemsSubSeminar &&
                _vm.agendasJson.itemsSubSeminar.length <
                  (_vm.agendasJson.items.length > 0 ? 4 : 5)
                  ? 'flex'
                  : 'inline-block',
            })},[(_vm.agendasJson.items && _vm.agendasJson.items.length > 0)?_c('div',{staticClass:"tab-new u-mr30",class:{
                'cursor-default': _vm.isSetting == 1,
                active: _vm.agendaType === 0,
              },staticStyle:{"display":"inline-block"},on:{"click":function($event){return _vm.changeAgendaType(0)}}},[_vm._v(" "+_vm._s(_vm.$t("大会日程"))+" "),_c('div',{staticClass:"underline"})]):_vm._e(),_vm._l((_vm.agendasJson.itemsSubSeminar),function(field,index){return _c('div',{key:index,staticClass:"tab-new u-mr30",class:{
                'cursor-default': _vm.isSetting == 1,
                active: _vm.agendaType === 1 && index == _vm.agendaType2Index,
              },staticStyle:{"display":"inline-block"},on:{"click":function($event){return _vm.changeAgendaType(1, index)}}},[_vm._v(" "+_vm._s(_vm.$i18nFlat( _vm.subSeminarI18n && _vm.subSeminarI18n[field.subSeminarId], "name", field.subSeminarName ))+" "),_c('div',{staticClass:"underline"})])})],2):_vm._e()]),_c('div',{staticClass:"g-schedule-info-new"},[_c('div',{staticClass:"left-line"},[(_vm.agendaType === 0 && _vm.agendasJson.items)?_c('div',{staticClass:"tab-body-new"},_vm._l((_vm.agendasJson.items),function(field,index){return _c('div',{key:index,staticClass:"schedule-item",class:field.hidden != 1 || _vm.extras.mergeAgenda.display == 0
                    ? 'hide-dot'
                    : '',style:({
                  background:
                    _vm.extras.scheduleContent.bgType == 'src'
                      ? 'url(' + _vm.extras.scheduleContent.bgImg + ')'
                      : _vm.extras.scheduleContent.bgColor,
                })},[_c('div',{staticClass:"_time"},[(
                      field.hidden != 1 || _vm.extras.mergeAgenda.display == 0
                    )?_c('span',{style:({
                      color:
                        _vm.extras.scheduleContent.timeText == 'custom'
                          ? _vm.extras.scheduleContent.timeFontColor
                          : '',
                      'font-size':
                        _vm.extras.scheduleContent.timeText == 'custom'
                          ? _vm.extras.scheduleContent.timeFontSize + 'px'
                          : '',
                      'font-style':
                        _vm.extras.scheduleContent.timeText == 'custom'
                          ? _vm.extras.scheduleContent.timeFontTilt == 'on'
                            ? 'italic'
                            : 'normal'
                          : '',
                      'font-Weight':
                        _vm.extras.scheduleContent.timeText == 'custom'
                          ? _vm.extras.scheduleContent.timeFontWeight == 'on'
                            ? 'bolder'
                            : ''
                          : '',
                    })},[_vm._v(_vm._s(_vm._f("formatTime")(field.startTime))+" - "+_vm._s(_vm._f("formatTime")(field.endTime)))]):_vm._e()]),_c('div',{staticClass:"_right"},[_c('div',{staticClass:"_title",style:({
                      color:
                        _vm.extras.scheduleContent.nameText == 'custom'
                          ? _vm.extras.scheduleContent.nameFontColor
                          : '',
                      'font-size':
                        _vm.extras.scheduleContent.nameText == 'custom'
                          ? _vm.extras.scheduleContent.nameFontSize + 'px'
                          : '',
                      'font-style':
                        _vm.extras.scheduleContent.nameText == 'custom'
                          ? _vm.extras.scheduleContent.nameFontTilt == 'on'
                            ? 'italic'
                            : 'normal'
                          : '',
                      'font-Weight':
                        _vm.extras.scheduleContent.nameText == 'custom'
                          ? _vm.extras.scheduleContent.nameFontWeight == 'on'
                            ? 'bolder'
                            : ''
                          : '',
                    })},[_vm._v(" "+_vm._s(_vm.$i18nField( _vm.agendaI18n && _vm.agendaI18n[field.agendaId], "name", field.name ))+" ")]),(_vm.extras.remark.display == 1)?_c('div',{staticClass:"remark"},[_vm._v(" "+_vm._s(_vm.$i18nField( _vm.agendaI18n && _vm.agendaI18n[field.agendaId], "remark", field.remark ))+" ")]):_vm._e(),_c('div',{staticClass:"guest-info"},_vm._l((field.guests),function(guest,index){return _c('div',{key:index,staticClass:"item"},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.$i18nField( _vm.guestsI18n && _vm.guestsI18n[guest.seminarGuestId], "name", guest.name )))]),(guest.enterprise)?_c('span',{staticClass:"duty"},[_vm._v(" | "+_vm._s(_vm.$i18nField( _vm.guestsI18n && _vm.guestsI18n[guest.seminarGuestId], "enterprise", guest.enterprise )))]):_vm._e(),(guest.duty)?_c('span',{staticClass:"duty"},[_vm._v(" | "+_vm._s(_vm.$i18nField( _vm.guestsI18n && _vm.guestsI18n[guest.seminarGuestId], "duty", guest.duty )))]):_vm._e(),_c('span',{staticClass:"dunhao"},[_vm._v(" ")])])}),0)])])}),0):_vm._e(),(_vm.agendaType === 1 && _vm.agendasJson.itemsSubSeminar)?_c('div',{staticClass:"tab-body-new"},_vm._l((_vm.agendasJson.itemsSubSeminar),function(field,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.agendaType2Index == index),expression:"agendaType2Index == index"}],key:index},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.agendaType === 1 && _vm.agendasJson.itemsSubSeminar),expression:"agendaType === 1 && agendasJson.itemsSubSeminar"}]},_vm._l((field.items),function(item,agendaIndex){return _c('div',{key:agendaIndex,staticClass:"schedule-item",class:item.hidden != 1 || _vm.extras.mergeAgenda.display == 0
                        ? 'hide-dot'
                        : '',style:({
                      background:
                        _vm.extras.scheduleContent.bgType == 'src'
                          ? 'url(' + _vm.extras.scheduleContent.bgImg + ')'
                          : _vm.extras.scheduleContent.bgColor,
                    })},[_c('div',{staticClass:"_time"},[(
                          item.hidden != 1 || _vm.extras.mergeAgenda.display == 0
                        )?_c('span',{style:({
                          color:
                            _vm.extras.scheduleContent.timeText == 'custom'
                              ? _vm.extras.scheduleContent.timeFontColor
                              : '',
                          'font-size':
                            _vm.extras.scheduleContent.timeText == 'custom'
                              ? _vm.extras.scheduleContent.timeFontSize + 'px'
                              : '',
                          'font-style':
                            _vm.extras.scheduleContent.timeText == 'custom'
                              ? _vm.extras.scheduleContent.timeFontTilt == 'on'
                                ? 'italic'
                                : 'normal'
                              : '',
                          'font-Weight':
                            _vm.extras.scheduleContent.timeText == 'custom'
                              ? _vm.extras.scheduleContent.timeFontWeight == 'on'
                                ? 'bolder'
                                : ''
                              : '',
                        })},[_vm._v(_vm._s(_vm._f("formatTime")(item.startTime))+" - "+_vm._s(_vm._f("formatTime")(item.endTime)))]):_vm._e()]),_c('div',{staticClass:"_right"},[_c('div',{staticClass:"_title",style:({
                          color:
                            _vm.extras.scheduleContent.nameText == 'custom'
                              ? _vm.extras.scheduleContent.nameFontColor
                              : '',
                          'font-size':
                            _vm.extras.scheduleContent.nameText == 'custom'
                              ? _vm.extras.scheduleContent.nameFontSize + 'px'
                              : '',
                          'font-style':
                            _vm.extras.scheduleContent.nameText == 'custom'
                              ? _vm.extras.scheduleContent.nameFontTilt == 'on'
                                ? 'italic'
                                : 'normal'
                              : '',
                          'font-Weight':
                            _vm.extras.scheduleContent.nameText == 'custom'
                              ? _vm.extras.scheduleContent.nameFontWeight == 'on'
                                ? 'bolder'
                                : ''
                              : '',
                        })},[_vm._v(" "+_vm._s(_vm.$i18nField( _vm.agendaI18n && _vm.agendaI18n[item.agendaId], "name", item.name ))+" ")]),(_vm.extras.remark.display == 1)?_c('div',{staticClass:"remark"},[_vm._v(" "+_vm._s(_vm.$i18nField( _vm.agendaI18n && _vm.agendaI18n[item.agendaId], "address", item.address ))+" ")]):_vm._e(),_c('div',{staticClass:"guest-info"},_vm._l((item.guests),function(guest,index){return _c('div',{key:index,staticClass:"item"},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.$i18nField( _vm.guestsI18n && _vm.guestsI18n[guest.seminarGuestId], "name", guest.name )))]),(guest.enterprise)?_c('span',{staticClass:"duty"},[_vm._v(" | "+_vm._s(_vm.$i18nField( _vm.guestsI18n && _vm.guestsI18n[guest.seminarGuestId], "enterprise", guest.enterprise )))]):_vm._e(),(guest.duty)?_c('span',{staticClass:"duty"},[_vm._v(" | "+_vm._s(_vm.$i18nField( _vm.guestsI18n && _vm.guestsI18n[guest.seminarGuestId], "duty", guest.duty )))]):_vm._e(),_c('span',{staticClass:"dunhao"},[_vm._v(" ")])])}),0)])])}),0)])}),0):_vm._e()])])],1):_vm._e(),(_vm.agendas.length == 0)?_c('div',{staticClass:"m-nodata-body"},[_c('img',{attrs:{"src":require("@/assets/images/nodata.png")}}),_c('div',{staticClass:"m-nodata"},[_vm._v(_vm._s(_vm.$t("暂无数据")))])]):_vm._e()])],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }